// extracted by mini-css-extract-plugin
module.exports = {"logoConatiner":"Logo_logoConatiner__11emb","imageLogo":"Logo_imageLogo__2bNI1"};